import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import Notification from 'components/NotificationContent/Notification/index';
import style from './style.scss'; //NOSONAR

let actions = [];
let notificationsAux = [];
let index = 0;
const NotificationContent = () => {
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        actions.push(PubSub.register('open_snackbar', getNotify));
        actions.push(PubSub.register('remove_snackbar', removeNotify));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
        }}, []);


    const getNotify = (payload) => {
        let value = payload.value;
        let {type} = value;

        if(type && _verifyType(type, notificationsAux)) return false;

        value.index = index;
        value.id = new Date().getTime();
        notificationsAux.push(value);
        setNotifications([...notificationsAux]);
        index++;
    }

    const _verifyType = (type, notificationsData) => {
        return notificationsData.filter(item => item.type === type).filter(Boolean).length > 0;
    };

    const removeNotify = (payload) => {
        const element = notificationsAux.findIndex((item) => {
            return item.index === payload.value.index
        });
        if(element === -1) return false;
        notificationsAux.splice(element,1);
        setNotifications([...notificationsAux]);
    }

    return (
        <div className={'notification-wrap'}>
            {notifications.map(item => {
                return <Notification {...item} key={item.id} />
            })}
        </div>
    )
}

export default NotificationContent;
